<template>
  <v-container>
    <v-row>
      <v-col class="custom-col">
        <TestPriceAlert
          :price="price"
          :showReanalysisAlert="showReanalysisAlert"
          :medicare="medicare"
        >
          <template v-slot:funding>
            <slot name="funding"></slot>
          </template>
        </TestPriceAlert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TestPriceAlert from "./TestPriceAlert.vue";

export default {
  props: { price: Number, showReanalysisAlert: Boolean, medicare: Boolean },
  components: { TestPriceAlert },
};
</script>
